<template>
  <div id="Account_User">
    <!-- 編輯個人帳號 -->
    <div
      id="husers"
      class="table-style fade show"
      role="tabpanel"
      aria-labelledby="hau"
    >
      <div class="col-12 pt-3 pb-4">
        <div class="form-row">
          <!-- 帳號 -->
          <div class="form-group col-md-3">
            <v-label
              for="UserId"
              LabText="帳號(UserId)："
              Labbold="true"
            />
            <input
              id="UserId"
              class="form-control"
              type="text"
              v-model="EditData.UserId"
              readonly
            >
          </div>
          <!-- 姓名 -->
          <div class="form-group col-md-3">
            <v-small />
            <v-label
              for="UserName"
              LabText="繳款人名稱(UserName)："
              Labbold="true"
            />
            <input
              id="UserName"
              class="form-control nukWord"
              type="text"
              placeholder="請填寫您的大名"
              v-model="EditData.UserName"
              required
            >
          </div>
        </div>
        <div class="form-row">
          <!-- 信箱 -->
          <div class="form-group col-md-3">
            <v-small />
            <v-label
              for="Email"
              LabText="聯絡信箱(Email)："
              Labbold="true"
            />
            <input
              id="Email"
              class="form-control"
              type="email"
              v-model="EditData.Email"
              placeholder=""
              required
            >
          </div>
          <!-- 電話 -->
          <div class="form-group col-md-3">
            <v-small />
            <v-label
              for="Telephone"
              LabText="聯絡電話(Phone)："
              Labbold="true"
            />
            <input
              id="Telephone"
              class="form-control"
              type="tel"
              v-model="EditData.Telephone"
              placeholder=""
              required
            >
          </div>
        </div>
        <div class="form-row pb-2">
          <!-- 地址 -->
          <div class="form-group col-md-3">
            <v-label
              for="Address"
              LabText="聯絡地址(Address)："
              Labbold="true"
            />
            <input
              id="Address"
              class="form-control"
              type="text"
              v-model="EditData.Address"
              placeholder=""
              required
            >
          </div>
          <!-- 統編 -->
          <div class="form-group col-md-3">
            <v-label
              for="Unino"
              LabText="公司統編(Company ID Number)："
              Labbold="true"
            />
            <input
              id="Unino"
              class="form-control"
              type="tel"
              placeholder=""
              v-model="EditData.Unino"
              required
            >
          </div>
        </div>
        <!-- 開關修改密碼,民眾、廠商 -->
        <v-button
          v-if="UserType >= '5'"
          :btn-text="EditPW ? '關閉更改密碼' : '點擊更改密碼'"
          btn-type="warning"
          btn-size="sm"
          @click.native="EditPassword"
        />
        <!-- 確認密碼 -->
        <div
          v-if="UserType >= '5'"
          class="form-row mt-2"
        >
          <div
            v-if="EditPW"
            class="form-group col-md-3"
          >
            <v-label
              for="ChangePw"
              LabText="請輸入新密碼(Password)："
              Labbold="true"
            />
            <form>
              <input
                id="ChangePw"
                class="form-control"
                type="password"
                v-model="ChangePw"
                required
                autocomplete
              >
            </form>
          </div>
          <div
            v-if="EditPW"
            class="form-group col-md-3"
          >
            <v-label
              for="CheckPw"
              LabText="請確認新密碼(Check Password)："
              Labbold="true"
            />
            <form>
              <input
                id="CheckPw"
                class="form-control"
                type="password"
                v-model="CheckChangePw"
                required
                autocomplete
              >
            </form>
          </div>
        </div>
        <hr>
        <v-button
          btn-text="更新(Update)"
          btn-type="primary"
          @click.native="PostAccountModify"
        />
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import vSmall from '@/components/Features/Small'
import { apiAccountQuery, apiAccountModify } from '../../Api/api'
export default {
  components: {
    vSmall
  },
  data () {
    return {
      UserType: localStorage.getItem('M_UserType'),
      // CheckEmail: localStorage.getItem('CheckEmail') ? 'true' : 'false',
      EditData: {
        UserName: null,
        Email: null,
        Telephone: null,
        Address: null,
        UserId: null,
        Unino: null
      },
      EditPW: false,
      ChangePw: '',
      CheckChangePw: ''
    }
  },
  mounted () {
    this.PostAccountQuery()
  },
  methods: {
    PostAccountQuery () { // 查詢 F_API 003
      // 定義資料
      const vm = this
      const NewData = JSON.parse(localStorage.getItem('M_Identity'))
      // 呼叫API
      apiAccountQuery(NewData).then(
        res => {
          if (res !== undefined) {
            vm.EditData = res
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    PostAccountModify () { // 變更 F_API 004
      // 定義資料
      const vm = this
      const Identity = JSON.parse(localStorage.getItem('M_Identity'))
      const NewData = Object.assign(Identity, vm.EditData)
      NewData.NeedReceipt = 0
      delete NewData.Msg
      delete NewData.ErrorCode
      // 判斷身分：民眾、廠商 可修改密碼
      if (vm.UserType >= '5') {
        NewData.UserPasswd = vm.ChangePw
        if (vm.ChangePw !== vm.CheckChangePw) {
          vm.$bus.$emit('Modals', '密碼不一致')
          $('#CheckError').modal('show')
          vm.ChangePw = ''
          vm.CheckChangePw = ''
          return false
        }
      } else {
        NewData.UserPasswd = ''
      }
      // Email防呆
      if (NewData.Email === '') {
        vm.$bus.$emit('Modals', '聯絡信箱為必填欄位。')
        $('#CheckError').modal('show')
        return false
      }
      // Email防呆
      if (NewData.Telephone === '') {
        vm.$bus.$emit('Modals', '聯絡電話為必填欄位。')
        $('#CheckError').modal('show')
        return false
      }
      // Email防呆
      if (NewData.UserName === '') {
        vm.$bus.$emit('Modals', '繳款人名稱為必填欄位。')
        $('#CheckError').modal('show')
        return false
      }
      // 呼叫API
      apiAccountModify(NewData).then(
        res => {
          if (res !== undefined) {
            vm.$bus.$emit('LoginCheckUser', 'true')
            localStorage.setItem('M_Menu', 'true')
            vm.ChangePw = ''
            vm.CheckChangePw = ''
            vm.$bus.$emit('Modals', '修改成功')
            $('#CheckOk').modal('show')
            vm.PostAccountQuery()
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    EditPassword () { // 顯示隱藏密碼欄位
      const data = this.EditPW
      if (data === true) {
        this.EditPW = false
      } else {
        this.EditPW = true
      }
    },
    EmailLogout () { // 登出
      this.$bus.$emit('LogOutCheckUser', 'false')
    }
  }
}
</script>
